import { apiRoute, API_V1 } from '../helpers/api-route'
import { fetchWrapper } from '../helpers/fetch-wrapper'

export const zipService = {
  poll
}

function poll (project) {
  return fetchWrapper.get(`${apiRoute()}${API_V1}/admin/training/zip_poll/${project.pid}`)
}
